export const translation = {
  nav: {
    home: 'Startseite',
    guides: 'Guides',
    categories: 'Kategorien',
    article: 'Artikel',
    shoppingGuide: 'Kaufberater',
    explore: 'Spreadsheet Erkunden',
    buyNow: 'Jetzt Kaufen',
  },
  hero: {
    eyebrow: 'DIE ALLCHINABUY RESSOURCENZENTRALE',
    headline: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Kaufberater an Einem Ort Finden',
    subheadline: 'Erkunden Sie organisierte AllChinaBuy Spreadsheet-Ressourcen, Produktkategorien, vertrauenswürdige Verkäufer-Guides, QC-Informationen, Versandkosten, Lager-Tipps, Bewertungen und praktische Kaufberater, bevor Sie kaufen.',
    ctaExplore: 'AllChinaBuy Spreadsheet Erkunden',
    ctaBrowse: 'Kaufberater Durchsuchen',
    trustLine: 'Unabhängige Ressource • Praktische Guides • Aktualisierter Inhalt',
  },
  whatIs: {
    h2: 'Was ist das AllChinaBuy Spreadsheet?',
    copy: 'Das AllChinaBuy Spreadsheet ist eine strukturierte Ressource, die die Produktsuche erleichtert. Erkunden Sie Produkte, Kategorien, Verkäufer, QC-Informationen, Versandressourcen und Kaufberater an einem organisierten Ort.',
  },
  everythingNeed: {
    h2: 'Alles, Was Sie Brauchen, um AllChinaBuy-Produkte zu Recherchieren',
    cards: {
      productDiscovery: 'Produktentdeckung',
      productDiscoveryDesc: 'Erkunden Sie organisierte Produkt- und Kategorieressourcen.',
      sellerResearch: 'Verkäufer-Recherche',
      sellerResearchDesc: 'Vergleichen Sie Verkäuferinformationen und Kaufüberlegungen.',
      qcInfo: 'QC-Informationen',
      qcInfoDesc: 'Verstehen Sie Qualitätskontroll-Fotos und deren Grenzen.',
      shippingGuides: 'Versandguides',
      shippingGuidesDesc: 'Lernen Sie Versandmethoden, Kosten und häufige Fragen kennen.',
    },
  },
  popularResources: {
    h2: 'Beliebte AllChinaBuy-Ressourcen',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Bewertung',
    shippingCost: 'AllChinaBuy Versandkosten',
    warehouse: 'AllChinaBuy Lager',
    coupon: 'AllChinaBuy Gutschein',
    discountCode: 'AllChinaBuy Rabattcode',
    legit: 'AllChinaBuy Seriös',
    qc: 'AllChinaBuy QC',
    trustedSellers: 'Vertrauenswürdige Verkäufer',
    buyingGuides: 'Kaufberater',
  },
  productCategories: {
    h2: 'AllChinaBuy-Produktkategorien Erkunden',
    shoes: 'Schuhe',
    hoodiesSweaters: 'Hoodies/Pullover',
    tShirts: 'T-Shirts',
    jackets: 'Jacken',
    pantsShorts: 'Hosen/Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Trikots',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    otherStuff: 'Sonstiges',
  },
  howToUse: {
    h2: 'Wie Man das AllChinaBuy Spreadsheet Verwendet',
    steps: {
      step1: 'Wählen Sie eine Kategorie.',
      step2: 'Recherchieren Sie Produkte und Verkäufer.',
      step3: 'Vergleichen Sie Optionen.',
      step4: 'Überprüfen Sie QC-Informationen.',
      step5: 'Prüfen Sie Lager- und Versandinformationen.',
      step6: 'Treffen Sie eine fundierte Entscheidung.',
    },
    cta: 'Beginnen Sie, das Spreadsheet zu Erkunden',
  },
  researchFirst: {
    h2: 'Zuerst Recherchieren. Mit Mehr Vertrauen Kaufen.',
    copy: 'Das Verständnis von Verkäufer-Recherche, Produktinformationen, QC-Prozessen, Versandoptionen und Kauf-Risiken hilft Ihnen, intelligentere Entscheidungen zu treffen. Unsere Guides führen Sie durch jeden Schritt des Rechercheprozesses.',
  },
  stayInformed: {
    h2: 'Bleiben Sie Informiert, Bevor Sie Kaufen',
    copy: 'Überprüfen Sie immer Produktinformationen, Verkäuferdetails, Zahlungsinformationen, Versandbedingungen und URLs. Kein Spreadsheet kann Qualität, Authentizität oder Transaktionsergebnisse garantieren.',
    cta: 'Sicherheitsguide Lesen',
  },
  readyToExplore: {
    h2: 'Bereit, AllChinaBuy zu Erkunden?',
    copy: 'Starten Sie mit dem AllChinaBuy Spreadsheet, vergleichen Sie Produkte und Verkäufer, lernen Sie QC und Versand kennen, und nutzen Sie unsere Kaufberater für besser informierte Entscheidungen.',
    ctaExplore: 'AllChinaBuy Spreadsheet Erkunden',
    ctaVisit: 'Hauptwebsite Besuchen',
  },
  footer: {
    disclaimer: 'Diese Website ist eine unabhängige Informationsressource. Informationen können sich ändern und sollten vor dem Kauf unabhängig überprüft werden.',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.',
    links: {
      home: 'Startseite',
      guides: 'Guides',
      safety: 'Sicherheit',
      contact: 'Kontakt',
    },
  },
  categories: {
    shoes: 'Schuhe',
    hoodiesSweaters: 'Hoodies/Pullover',
    tShirts: 'T-Shirts',
    jackets: 'Jacken',
    pantsShorts: 'Hosen/Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Trikots',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    otherStuff: 'Sonstiges',
  },
  pillarArticles: {
    h2: 'Säulen-Guides & Ressourcen',
  },
  article: {
    readMore: 'Weiterlesen',
    relatedArticles: 'Verwandte Artikel',
    backToHome: 'Zurück zur Startseite',
  },
};